module.exports = __webpack_public_path__ + "static/media/Bicocca - PR PINK - 3955_3377_3364_3135.e72d0dc9.jpg";